//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { gsap } from 'gsap'
import WorkAreaWidget from "./objects/WorkAreaWidget.vue";

const CLOSE_ANIMATION_MS = 320
const OPEN_DURATION = 0.45
const CLOSE_DURATION = 0.28

export default {
  name: "AsyncObjectSnippetTooltip",
  components: {
    WorkAreaWidget,
  },
  props: {
    vistatObject: {
      type: [String, Object],
      default: null
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    closeOnMouseLeave: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      content: null,
      loading: false,
      description: {},
      loaded: false,
      closeAnimationMs: CLOSE_ANIMATION_MS,
      isOpen: false,
      openTween: null,
      closeTween: null,
      isClosing: false,
      closeTimer: null,
      ignoreDocumentClick: false,
    }
  },
  computed: {
    objectId() {
      return typeof this.vistatObject === "object" ? this.vistatObject.id : this.vistatObject
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
    this.cancelScheduledClose()
    this.killAnimations()
  },
  created() {
    if (typeof this.vistatObject === "object") {
      this.loading = false
      this.loaded = true
      this.processContent(this.vistatObject)
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
  },
  methods: {
    handleTriggerMouseEnter() {
      this.openPopover()
    },
    handleTriggerMouseLeave(event) {
      if (!this.closeOnMouseLeave) return
      if (this.isRelatedTargetInsideContent(event.relatedTarget)) return
      this.scheduleClose()
    },
    handleContentMouseLeave(event) {
      if (!this.closeOnMouseLeave) return
      if (this.isRelatedTargetInsideTrigger(event.relatedTarget)) return
      this.scheduleClose()
    },
    isRelatedTargetInsideContent(target) {
      return Boolean(target && this.$refs.content && this.$refs.content.contains(target))
    },
    isRelatedTargetInsideTrigger(target) {
      return Boolean(target && this.$refs.trigger && this.$refs.trigger.contains(target))
    },
    openPopover() {
      this.cancelScheduledClose()
      this.ignoreDocumentClick = true
      setTimeout(() => {
        this.ignoreDocumentClick = false
      }, 0)
      if (this.isClosing) {
        this.isClosing = false
      }
      if (!this.isOpen) {
        this.isOpen = true
      }
      this.$emit('update:open', true)

      if (this.content !== null) return

      if (!this.loading) {
        this.loading = true
        this.$store.dispatch('objects/publicObject', this.vistatObject).then(object => {
          this.processContent(object)
          this.loaded = true
        })
      }
    },
    scheduleClose() {
      this.cancelScheduledClose()
      this.closeTimer = setTimeout(() => {
        this.handleClose()
      }, 120)
    },
    cancelScheduledClose() {
      if (!this.closeTimer) return
      clearTimeout(this.closeTimer)
      this.closeTimer = null
    },
    handleDocumentClick(event) {
      if (!this.isOpen) return
      if (this.ignoreDocumentClick) return
      const target = event.target
      if (this.$refs.trigger?.contains(target) || this.$refs.content?.contains(target)) return
      this.handleClose()
    },
    handleClose() {
      this.cancelScheduledClose()
      if (this.isClosing || !this.isOpen) return

      this.isClosing = true
      this.animateClose()
        .finally(() => {
          this.isClosing = false
          this.isOpen = false
          this.$emit('update:open', false)
        })
    },
    processContent({ ...object }) {
      try {
        if (typeof object.has_image === 'undefined') {
          object.has_image = object.images.length > 0
        }
      } catch {
        object.has_image = false
      }

      this.content = object

      this.description = {
        object_id: object.id,
        attr_id: object?.relatedAttrId || null,
        object: this.content
      }
    },
    manuallyOpen() {
      this.openPopover()
    },
    closePopover() {
      this.handleClose()
    },
    getPopoverEl() {
      return this.$refs.instance?.$refs?.popover || null
    },
    killAnimations() {
      const root = this.getPopoverEl()
      if (!root) return

      const inner = root.querySelector('.popover-inner')
      const arrow = root.querySelector('.popover-arrow')
      const targets = [root, inner, arrow].filter(Boolean)

      gsap.killTweensOf(targets)
      gsap.set(root, { clearProps: 'opacity' })
      if (inner) gsap.set(inner, { clearProps: 'opacity,transform' })
      if (arrow) gsap.set(arrow, { clearProps: 'opacity' })
      this.openTween = null
      this.closeTween = null
    },
    getPlacementOffset(root) {
      const placement = root.getAttribute('x-placement') || ''

      return {
        x: placement.startsWith('left') ? 10 : placement.startsWith('right') ? -10 : 0,
        y: placement.startsWith('top') ? 10 : placement.startsWith('bottom') ? -10 : 0,
      }
    },
    getTransformOrigin(root) {
      const placement = root.getAttribute('x-placement') || ''

      if (placement.startsWith('top')) return 'bottom center'
      if (placement.startsWith('bottom')) return 'top center'
      if (placement.startsWith('left')) return 'center right'
      if (placement.startsWith('right')) return 'center left'
      return 'center center'
    },
    animateOpen() {
      this.killAnimations()

      const root = this.getPopoverEl()
      const inner = root?.querySelector('.popover-inner')
      const arrow = root?.querySelector('.popover-arrow')
      if (!root || !inner) return

      const { x, y } = this.getPlacementOffset(root)
      const transformOrigin = this.getTransformOrigin(root)

      // Popper позиционирует root через transform — трогаем только opacity
      gsap.set(root, { opacity: 0 })
      gsap.set(inner, {
        opacity: 0,
        scale: 0.9,
        x,
        y,
        transformOrigin,
      })
      if (arrow) gsap.set(arrow, { opacity: 0 })

      const timeline = gsap.timeline()
        .to(root, {
          opacity: 1,
          duration: OPEN_DURATION,
          ease: 'power2.out',
        }, 0)
        .to(inner, {
          opacity: 1,
          scale: 1,
          x: 0,
          y: 0,
          duration: OPEN_DURATION,
          ease: 'back.out(1.6)',
        }, 0)

      if (arrow) {
        timeline.to(arrow, {
          opacity: 1,
          duration: 0.22,
          ease: 'power2.out',
        }, 0.12)
      }

      this.openTween = timeline
    },
    animateClose() {
      const root = this.getPopoverEl()
      const inner = root?.querySelector('.popover-inner')
      const arrow = root?.querySelector('.popover-arrow')

      if (!root || !inner) {
        return Promise.resolve()
      }

      if (this.openTween) {
        this.openTween.kill()
        this.openTween = null
      }

      const targets = [root, inner, arrow].filter(Boolean)
      gsap.killTweensOf(targets)

      const { x, y } = this.getPlacementOffset(root)
      const transformOrigin = this.getTransformOrigin(root)
      const exitX = x ? x * 0.5 : 0
      const exitY = y ? y * 0.5 : 6

      gsap.set(inner, { transformOrigin })

      return new Promise((resolve) => {
        const timeline = gsap.timeline({ onComplete: resolve })

        if (arrow) {
          timeline.to(arrow, {
            opacity: 0,
            duration: 0.12,
            ease: 'power1.in',
          }, 0)
        }

        timeline.to(inner, {
          opacity: 0,
          scale: 0.94,
          x: exitX,
          y: exitY,
          duration: CLOSE_DURATION,
          ease: 'power2.in',
        }, 0)

        timeline.to(root, {
          opacity: 0,
          duration: CLOSE_DURATION * 0.8,
          ease: 'power1.in',
        }, 0.06)

        this.closeTween = timeline
      })
    },
  },
}
